import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    betWinData: {},
    historyTriggered: false,
    wScale: 1,
    hScale: 1,
    bonusState: {}
};

export const betWinSlice = createSlice({
    name: 'betWin',
    initialState,
    reducers: {
        setBetWinData(state, action) {
            state.betWinData = action.payload;
        },
        setHistoryTriggered(state, action) {
            state.historyTriggered = action.payload;
        },
        setWScale(state, action) {
            state.wScale = action.payload;
        },
        setHScale(state, action) {
            state.hScale = action.payload;
        },
        setBonusState(state, action) {
            state.bonusState = action.payload;
        }
    }
});

export default betWinSlice;